module.exports = __webpack_public_path__ + "79ffb63e1ef24902b7079fc590365d36.jpg";